/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

export interface IdpSubmissionGetDocumentPagesGet$Params {
  submissionId: string;
  documentId: string;
}

export function idpSubmissionGetDocumentPagesGet(
  http: HttpClient,
  rootUrl: string,
  params: IdpSubmissionGetDocumentPagesGet$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<Blob>> {
  const rb = new RequestBuilder(rootUrl, idpSubmissionGetDocumentPagesGet.PATH, 'get');
  if (params) {
    rb.query('submissionId', params.submissionId, {});
    rb.query('documentId', params.documentId, {});
  }

  return http
    .request(rb.build({ responseType: 'blob', accept: 'application/pdf', context }))
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => r as StrictHttpResponse<Blob>),
    );
}

idpSubmissionGetDocumentPagesGet.PATH = '/IdpSubmission/GetDocumentPages';
